import axios from 'axios'
const state = {
    loading: false,
    categories: [],
    category: {
        id: null,
        exchange_updatable: 1,
        exchange_records: {  
            tableHeaders: [],
            tableData: [],
            accessTableData: [],
            loading: false,
            tableMeta: {
                total: 10,
                page: 1,
                perpage: 1000,
            },
        },
        information: {
          name: '',
          code: {
            desc: "Code",
            value: "",
          },
          exchange: {
            desc: "Exchange",
            value: null,
          },
        }
    },
    tableOptions: {
        tableHeaders: [],
        tableData: [],
        accessTableData: [],
        loading: false,
        tableMeta: {
            total: 10,
            page: 1,
        },
    }
};
const getters = {
    getLoadingStatus(state) {
        return state.loading;
    },
    getCategory(state) {
        return state.category
    },
    getCategories(state) {
        return state.categories
    },
    getTableOptions(state) {
        return state.tableOptions
    },
};

const mutations = {
    setLoadingStatus(state, status) {
        state.loading = status;
    },
    setCategory(state, category) {
        state.category.id = category.id;
        state.category.exchange_updatable = category.exchange_updatable;
        state.category.information.name = category.name;
        state.category.information.code.value = category.code;
        state.category.information.exchange.value = category.exchange;
        state.category.exchange_records.tableHeaders = ["date","Exchange","settings",];
        state.category.exchange_records.tableData = category.exchange_records;
        state.category.exchange_records.accessTableData = [["date"],["exchange"],];
        
    },
    setCategories(state, categories) {
        state.categories = categories
    },
    setLoading(state, status) {
        state.tableOptions.loading = status
    },
    setTableData(state, tableInfo) {
        state.tableOptions.tableHeaders = tableInfo.tableHeaders
        state.tableOptions.tableData = tableInfo.tableData
        state.tableOptions.accessTableData = tableInfo.accessTableData
        state.tableOptions.tableMeta.total = tableInfo.tableMeta.total
        state.tableOptions.tableMeta.page = tableInfo.tableMeta.page
    },
};

const actions = {
    async fetchCategories({ commit }, queryParams) {
        try {
            commit('setLoading', true)
            let params = {};
            for (let key in queryParams) {
                if (queryParams[key]) {
                    params[key] = queryParams[key];
                }
            }
            if(!queryParams.paginated) params.paginated = queryParams.paginated;
            const response = await axios.get("/catalog/category", {
                params,
            });
            commit('setCategories', response.data.data)
            // commit('setTableData', {
            //     tableHeaders: [
            //         "name",
            //         "Code",
            //         "Exchange",
            //         "settings",
            //     ],
            //     tableData: response.data.data,
            //     accessTableData: [
            //         ["name"],
            //         ["code"],
            //         ["exchange"],
            //     ],
            //     tableMeta: {
            //         total: response.data.meta.total,
            //         page: response.data.meta.current_page,
            //     },
            // })
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoading', false)
        }
    },
    async fetchCategory({ commit }, id) {
        try {
            commit('setLoadingStatus', true)
            const response = await axios.get(`/accounting/coin/${id}`);
            commit('setCategory', response.data.data);
            state.category.information.exchange_records.tableMeta = {
                total: response.data.meta.total,
                page: response.data.meta.current_page,
                perpage: response.data.meta.per_page,
            };
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoadingStatus', false)
        }
    },
    
}


export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}